import { render, staticRenderFns } from "./uuid.vue?vue&type=template&id=3166c8c9&scoped=true"
import script from "./uuid.vue?vue&type=script&lang=js"
export * from "./uuid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3166c8c9",
  null
  
)

export default component.exports